import { createRouter, createWebHistory } from 'vue-router';
import Login from '../views/Login.vue';
import Config from '../views/Config.vue';

// Vue CLI 中使用 process.env.BASE_URL（无需 import.meta.env）
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/config',
      name: 'Config',
      component: Config,
      // 路由守卫：未登录不能访问配置页
      beforeEnter: (to, from, next) => {
        const token = localStorage.getItem('token');
        token ? next() : next('/');
      }
    }
  ]
});

export default router;